import * as ActionTypes from '../constants/actions';

const default_state = {
	activeCall : {},
	participants: []
};

export default function patient(state = default_state, action) {
	switch (action.type) {
		case ActionTypes.PATIENTS.SET_ACTIVE_CALL_DATA: {
			return {
				...state,
				activeCall : action.activeCall
			};
		}
		case ActionTypes.PATIENTS.UNSET_ACTIVE_CALL_DATA: {
			return {
				...state,
				activeCall : {}
			};
		}
		case ActionTypes.PATIENTS.SET_PARTICIPANTS: {
			return {
				...state,
				participants : action.participants
			};
		}
		default: {
			return state;
		}
	}
}
